var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
function getGlobal() {
  const OT = globalThis.OpenTicket || {};
  globalThis.OpenTicket = OT;
  return OT;
}
function unknownErrorInput(message) {
  const slug = "log.oterror.unknown.error";
  const noMessage = "<nomessage>";
  const input = {
    message: noMessage,
    name: "UnknownError",
    slug
  };
  if (!message) {
    return input;
  }
  if (typeof message === "string") {
    return { ...input, message };
  }
  if (message instanceof Error) {
    if (message.name && message.message) {
      return { ...input, message: `${message.name}: ${message.message}`, stack: message.stack };
    }
    if (message.name) {
      return { ...input, message: message.name, stack: message.stack };
    }
    if (message.message) {
      return { ...input, message: message.message, stack: message.stack };
    }
    return { ...input, stack: message.stack };
  }
  return input;
}
class OtError extends Error {
  constructor(name, slug, message) {
    super(message && typeof message === "string" ? message : "Unknown error");
    __publicField(this, "_isOtErrorV1_a8z9ppmibeaamd1o", 1);
    /**
     * Unique (incremental) id for the current session
     */
    __publicField(this, "id", 0);
    /**
     * Timestamp of the creation of the error
     */
    __publicField(this, "ts", 0);
    /**
     * Session ID of the current session.
     */
    __publicField(this, "session", "NOSESSION");
    /**
     * The URI of the current browser context.
     * Iff accessible.
     */
    __publicField(this, "href", null);
    /**
     * When the error has bubbled all the way to the global context without being caught.
     */
    __publicField(this, "uncaught", false);
    /**
     * Translatable representation of the error.
     *
     * This can use placeholders for the data in the `data` property.
     */
    __publicField(this, "slug");
    __publicField(this, "_cause", null);
    __publicField(this, "_sent", false);
    __publicField(this, "data", {});
    this.name = name && typeof name === "string" ? name : "OtError";
    this.slug = slug && typeof slug === "string" ? slug : "log.oterror.new.slug.missing";
    this.captureSession();
    this.ts = this.getTS();
    this.href = this.getHref();
  }
  /**
   * The cause of this error.
   *
   * Errors are often propagated through the system, where additional context should
   * be added for both the user and logging.
   * This allows the wrapping of the error, while keeping traceability.
   */
  get cause() {
    return this._cause;
  }
  /**
   * The 'sent status' of this error.
   *
   * This getter has been added for the sole benefit of allowing
   * the logging client to determine if all causal errors have been sent
   * to the log service.
   *
   * The accompanying setter allows the flag to be set, but not to be unset.
   */
  get otSent() {
    return this._sent;
  }
  set otSent(value) {
    if (value) {
      this._sent = true;
    }
  }
  /**
   * Set the cause of this error.
   *
   * This essentially wraps the given error within this error.
   * This allows adding context for both user and logging.
   */
  causedBy(error) {
    if (error && error instanceof OtError) {
      this._cause = error;
    } else {
      const input = unknownErrorInput(error);
      const unknownError = new class extends OtError {
      }(input.name, input.slug, input.message);
      if (input.stack) {
        unknownError.stack = input.stack;
      }
      unknownError.captureStackTrace(this.causedBy);
      const OT = getGlobal();
      if (OT.Log) {
        try {
          OT.Log.send(unknownError);
        } catch (_) {
        }
      }
      this._cause = unknownError;
    }
    return this;
  }
  /**
   * Add key value pairs to this error.
   *
   * This data is used for traceability, context, and messaging to the user.
   */
  addContext(key, value) {
    if (!key || typeof key !== "string") {
      throw new Error(`${this.name}: Failed to set data to error #${this.id}, invalid key`);
    }
    if (typeof value !== "string") {
      this.data[key] = `[${typeof value}]`;
    } else {
      this.data[key] = value;
    }
    return this;
  }
  /**
   * Retrieve the static data
   *
   * The (base) static values are:
   * `name`, `cause (id)`, `stack`, `uncaught`
   *
   * All static keys should be sandwiched between one underscore on each side.
   *
   * This allows the entire (a-zA-Z0-9) keyspace to be used by the context.
   */
  getStaticContext() {
    return {
      _cause_: this.cause ? this.cause.id.toFixed(0) : "",
      _name_: this.name,
      _stack_: this.stack || "",
      _uncaught_: this.uncaught ? "true" : "false"
    };
  }
  /**
   * Retrieve the data for the purpose of logging.
   *
   * This appends the static values to the dynamic context.
   * The static values always take precedence over dynamic context.
   *
   * However, all static keys should be sandwiched between one underscore
   * on each side, allowing the entire (a-zA-Z0-9) keyspace to be used
   * by the error's context.
   */
  getLogContext() {
    return {
      ...this.data,
      ...this.getStaticContext()
    };
  }
  /**
   * Helper to capture the stacktrace on this itself.
   *
   * If the stacktrace is not captured individually, they would include the
   * concrete implementations of the inherited Error class.
   */
  captureStackTrace(constructorOpt) {
    try {
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, constructorOpt);
      }
    } catch (_) {
    }
  }
  captureSession() {
    try {
      const OT = getGlobal();
      if (OT.Log?.captureSession) {
        OT.Log.captureSession(this);
      }
    } catch (_) {
    }
  }
  getHref() {
    try {
      return window?.location?.href || null;
    } catch (_) {
    }
    return null;
  }
  getTS() {
    try {
      return Date.now();
    } catch (_) {
    }
    return 0;
  }
}
function isOtError(e) {
  try {
    return !!e && typeof e === "object" && "_isOtErrorV1_a8z9ppmibeaamd1o" in e && !!e._isOtErrorV1_a8z9ppmibeaamd1o;
  } catch (_) {
    return false;
  }
}
function hasReason(value) {
  return !!value && typeof value === "object" && "reason" in value;
}
class UncaughtError extends OtError {
  /**
   * Specifically designed to work with the `global.addEventListener('error', ...)` global error handler syntax.
   */
  static fromHandler(event) {
    try {
      const error = hasReason(event) ? event.reason : event?.error;
      let _message;
      if (error) {
        if (typeof error === "string") {
          _message = error;
        } else if (error instanceof OtError) {
          error.uncaught = true;
          _message = error.name;
        } else if (error instanceof Error) {
          _message = `${error.name}: ${error.message}`;
        }
      }
      const e = new UncaughtError(
        "log.oterror.uncaught.error",
        `Uncaught error: ${_message || "Unknown error"}`
      );
      if (error) {
        if (error instanceof OtError) {
          e.causedBy(error);
        } else if (error instanceof Error && error.stack) {
          e.stack = error.stack;
        }
      }
      const OT = getGlobal();
      if (OT.Log) {
        try {
          OT.Log.send(e);
          return true;
        } catch (_) {
        }
      }
    } catch (err) {
      try {
        const OT = getGlobal();
        if (OT.Log) {
          OT.Log.send({
            id: 0,
            slug: "log.oterror.uncaught.handler.failed",
            message: "UncaughtError: Failed to handle uncaught error",
            getLogContext() {
              try {
                if (typeof err === "string") {
                  return { _message_: err };
                }
                if (err instanceof Error) {
                  return { _message_: err.toString() };
                }
                return { _message_: "" };
              } catch (_) {
                return {};
              }
            }
          });
        }
      } catch (_) {
      }
    }
    return false;
  }
  constructor(slug, message) {
    super("UncaughtError", slug, message);
    this.uncaught = true;
    this.captureStackTrace(UncaughtError);
  }
}
class UnknownError extends OtError {
  constructor(message) {
    const input = unknownErrorInput(message);
    super(input.name, input.slug, input.message);
    this.captureStackTrace(UnknownError);
  }
}
function registerGlobalErrorHandlers() {
  try {
    const OT = getGlobal();
    if (OT.Log_GlobalErrorHandlersRegistered) {
      return;
    }
    if (globalThis?.addEventListener) {
      globalThis.addEventListener("error", UncaughtError.fromHandler);
      globalThis.addEventListener("unhandledrejection", UncaughtError.fromHandler);
      OT.Log_GlobalErrorHandlersRegistered = true;
    }
  } catch (e) {
    console.error("Failed to register uncaught error handlers", e);
  }
}
let random = (bytes) => crypto.getRandomValues(new Uint8Array(bytes));
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
  let step = -~(1.6 * mask * defaultSize / alphabet.length);
  return (size = defaultSize) => {
    let id = "";
    while (true) {
      let bytes = getRandom(step);
      let j = step;
      while (j--) {
        id += alphabet[bytes[j] & mask] || "";
        if (id.length === size)
          return id;
      }
    }
  };
};
let customAlphabet = (alphabet, size = 21) => customRandom(alphabet, size, random);
const sessionIdGenerator = customAlphabet("346789ABCDEFGHJKLMNPQRTUVWXY", 12);
function parseConfig(config) {
  if (!config) {
    throw new Error("Missing the Log client config.");
  }
  if (config.session && typeof config.session !== "string") {
    throw new Error(`The Log client config session ID should be a string, got ${typeof config.session}.`);
  }
  if (!config.url) {
    throw new Error("Missing the Log client config url.");
  } else if (typeof config.url !== "string") {
    throw new Error(`The Log client config url should be a string, got ${typeof config.url}.`);
  }
  try {
    (() => new URL(config.url))();
  } catch (e) {
    throw new Error("The Log client config url should be a valid URL.");
  }
  if (!config.appName) {
    throw new Error("Missing the Log client config app name.");
  } else if (typeof config.appName !== "string") {
    throw new Error(`The Log client config app name should be a string, got ${typeof config.appName}.`);
  }
  if (!config.appVersion) {
    throw new Error("Missing the Log client config app version.");
  } else if (typeof config.appVersion !== "string") {
    throw new Error(`The Log client config app version should be a string, got ${typeof config.appVersion}.`);
  }
  return {
    appName: config.appName,
    appVersion: config.appVersion,
    rawSession: config.session || null,
    session: config.session || sessionIdGenerator(),
    url: config.url
  };
}
const SIZEOF_SHORT = 2;
const SIZEOF_INT = 4;
const FILE_IDENTIFIER_LENGTH = 4;
const SIZE_PREFIX_LENGTH = 4;
const int32 = new Int32Array(2);
const float32 = new Float32Array(int32.buffer);
const float64 = new Float64Array(int32.buffer);
const isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;
var Encoding;
(function(Encoding2) {
  Encoding2[Encoding2["UTF8_BYTES"] = 1] = "UTF8_BYTES";
  Encoding2[Encoding2["UTF16_STRING"] = 2] = "UTF16_STRING";
})(Encoding || (Encoding = {}));
class ByteBuffer {
  /**
   * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
   */
  constructor(bytes_) {
    this.bytes_ = bytes_;
    this.position_ = 0;
    this.text_decoder_ = new TextDecoder();
  }
  /**
   * Create and allocate a new ByteBuffer with a given size.
   */
  static allocate(byte_size) {
    return new ByteBuffer(new Uint8Array(byte_size));
  }
  clear() {
    this.position_ = 0;
  }
  /**
   * Get the underlying `Uint8Array`.
   */
  bytes() {
    return this.bytes_;
  }
  /**
   * Get the buffer's position.
   */
  position() {
    return this.position_;
  }
  /**
   * Set the buffer's position.
   */
  setPosition(position) {
    this.position_ = position;
  }
  /**
   * Get the buffer's capacity.
   */
  capacity() {
    return this.bytes_.length;
  }
  readInt8(offset) {
    return this.readUint8(offset) << 24 >> 24;
  }
  readUint8(offset) {
    return this.bytes_[offset];
  }
  readInt16(offset) {
    return this.readUint16(offset) << 16 >> 16;
  }
  readUint16(offset) {
    return this.bytes_[offset] | this.bytes_[offset + 1] << 8;
  }
  readInt32(offset) {
    return this.bytes_[offset] | this.bytes_[offset + 1] << 8 | this.bytes_[offset + 2] << 16 | this.bytes_[offset + 3] << 24;
  }
  readUint32(offset) {
    return this.readInt32(offset) >>> 0;
  }
  readInt64(offset) {
    return BigInt.asIntN(64, BigInt(this.readUint32(offset)) + (BigInt(this.readUint32(offset + 4)) << BigInt(32)));
  }
  readUint64(offset) {
    return BigInt.asUintN(64, BigInt(this.readUint32(offset)) + (BigInt(this.readUint32(offset + 4)) << BigInt(32)));
  }
  readFloat32(offset) {
    int32[0] = this.readInt32(offset);
    return float32[0];
  }
  readFloat64(offset) {
    int32[isLittleEndian ? 0 : 1] = this.readInt32(offset);
    int32[isLittleEndian ? 1 : 0] = this.readInt32(offset + 4);
    return float64[0];
  }
  writeInt8(offset, value) {
    this.bytes_[offset] = value;
  }
  writeUint8(offset, value) {
    this.bytes_[offset] = value;
  }
  writeInt16(offset, value) {
    this.bytes_[offset] = value;
    this.bytes_[offset + 1] = value >> 8;
  }
  writeUint16(offset, value) {
    this.bytes_[offset] = value;
    this.bytes_[offset + 1] = value >> 8;
  }
  writeInt32(offset, value) {
    this.bytes_[offset] = value;
    this.bytes_[offset + 1] = value >> 8;
    this.bytes_[offset + 2] = value >> 16;
    this.bytes_[offset + 3] = value >> 24;
  }
  writeUint32(offset, value) {
    this.bytes_[offset] = value;
    this.bytes_[offset + 1] = value >> 8;
    this.bytes_[offset + 2] = value >> 16;
    this.bytes_[offset + 3] = value >> 24;
  }
  writeInt64(offset, value) {
    this.writeInt32(offset, Number(BigInt.asIntN(32, value)));
    this.writeInt32(offset + 4, Number(BigInt.asIntN(32, value >> BigInt(32))));
  }
  writeUint64(offset, value) {
    this.writeUint32(offset, Number(BigInt.asUintN(32, value)));
    this.writeUint32(offset + 4, Number(BigInt.asUintN(32, value >> BigInt(32))));
  }
  writeFloat32(offset, value) {
    float32[0] = value;
    this.writeInt32(offset, int32[0]);
  }
  writeFloat64(offset, value) {
    float64[0] = value;
    this.writeInt32(offset, int32[isLittleEndian ? 0 : 1]);
    this.writeInt32(offset + 4, int32[isLittleEndian ? 1 : 0]);
  }
  /**
   * Return the file identifier.   Behavior is undefined for FlatBuffers whose
   * schema does not include a file_identifier (likely points at padding or the
   * start of a the root vtable).
   */
  getBufferIdentifier() {
    if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH) {
      throw new Error("FlatBuffers: ByteBuffer is too short to contain an identifier.");
    }
    let result = "";
    for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
      result += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + i));
    }
    return result;
  }
  /**
   * Look up a field in the vtable, return an offset into the object, or 0 if the
   * field is not present.
   */
  __offset(bb_pos, vtable_offset) {
    const vtable = bb_pos - this.readInt32(bb_pos);
    return vtable_offset < this.readInt16(vtable) ? this.readInt16(vtable + vtable_offset) : 0;
  }
  /**
   * Initialize any Table-derived type to point to the union at the given offset.
   */
  __union(t, offset) {
    t.bb_pos = offset + this.readInt32(offset);
    t.bb = this;
    return t;
  }
  /**
   * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
   * This allocates a new string and converts to wide chars upon each access.
   *
   * To avoid the conversion to string, pass Encoding.UTF8_BYTES as the
   * "optionalEncoding" argument. This is useful for avoiding conversion when
   * the data will just be packaged back up in another FlatBuffer later on.
   *
   * @param offset
   * @param opt_encoding Defaults to UTF16_STRING
   */
  __string(offset, opt_encoding) {
    offset += this.readInt32(offset);
    const length = this.readInt32(offset);
    offset += SIZEOF_INT;
    const utf8bytes = this.bytes_.subarray(offset, offset + length);
    if (opt_encoding === Encoding.UTF8_BYTES)
      return utf8bytes;
    else
      return this.text_decoder_.decode(utf8bytes);
  }
  /**
   * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
   * if a string then return a new one
   *
   * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
   * makes the behaviour of __union_with_string different compared to __union
   */
  __union_with_string(o, offset) {
    if (typeof o === "string") {
      return this.__string(offset);
    }
    return this.__union(o, offset);
  }
  /**
   * Retrieve the relative offset stored at "offset"
   */
  __indirect(offset) {
    return offset + this.readInt32(offset);
  }
  /**
   * Get the start of data of a vector whose offset is stored at "offset" in this object.
   */
  __vector(offset) {
    return offset + this.readInt32(offset) + SIZEOF_INT;
  }
  /**
   * Get the length of a vector whose offset is stored at "offset" in this object.
   */
  __vector_len(offset) {
    return this.readInt32(offset + this.readInt32(offset));
  }
  __has_identifier(ident) {
    if (ident.length != FILE_IDENTIFIER_LENGTH) {
      throw new Error("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
    }
    for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
      if (ident.charCodeAt(i) != this.readInt8(this.position() + SIZEOF_INT + i)) {
        return false;
      }
    }
    return true;
  }
  /**
   * A helper function for generating list for obj api
   */
  createScalarList(listAccessor, listLength) {
    const ret = [];
    for (let i = 0; i < listLength; ++i) {
      const val = listAccessor(i);
      if (val !== null) {
        ret.push(val);
      }
    }
    return ret;
  }
  /**
   * A helper function for generating list for obj api
   * @param listAccessor function that accepts an index and return data at that index
   * @param listLength listLength
   * @param res result list
   */
  createObjList(listAccessor, listLength) {
    const ret = [];
    for (let i = 0; i < listLength; ++i) {
      const val = listAccessor(i);
      if (val !== null) {
        ret.push(val.unpack());
      }
    }
    return ret;
  }
}
class Builder {
  /**
   * Create a FlatBufferBuilder.
   */
  constructor(opt_initial_size) {
    this.minalign = 1;
    this.vtable = null;
    this.vtable_in_use = 0;
    this.isNested = false;
    this.object_start = 0;
    this.vtables = [];
    this.vector_num_elems = 0;
    this.force_defaults = false;
    this.string_maps = null;
    this.text_encoder = new TextEncoder();
    let initial_size;
    if (!opt_initial_size) {
      initial_size = 1024;
    } else {
      initial_size = opt_initial_size;
    }
    this.bb = ByteBuffer.allocate(initial_size);
    this.space = initial_size;
  }
  clear() {
    this.bb.clear();
    this.space = this.bb.capacity();
    this.minalign = 1;
    this.vtable = null;
    this.vtable_in_use = 0;
    this.isNested = false;
    this.object_start = 0;
    this.vtables = [];
    this.vector_num_elems = 0;
    this.force_defaults = false;
    this.string_maps = null;
  }
  /**
   * In order to save space, fields that are set to their default value
   * don't get serialized into the buffer. Forcing defaults provides a
   * way to manually disable this optimization.
   *
   * @param forceDefaults true always serializes default values
   */
  forceDefaults(forceDefaults) {
    this.force_defaults = forceDefaults;
  }
  /**
   * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
   * called finish(). The actual data starts at the ByteBuffer's current position,
   * not necessarily at 0.
   */
  dataBuffer() {
    return this.bb;
  }
  /**
   * Get the bytes representing the FlatBuffer. Only call this after you've
   * called finish().
   */
  asUint8Array() {
    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
  }
  /**
   * Prepare to write an element of `size` after `additional_bytes` have been
   * written, e.g. if you write a string, you need to align such the int length
   * field is aligned to 4 bytes, and the string data follows it directly. If all
   * you need to do is alignment, `additional_bytes` will be 0.
   *
   * @param size This is the of the new element to write
   * @param additional_bytes The padding size
   */
  prep(size, additional_bytes) {
    if (size > this.minalign) {
      this.minalign = size;
    }
    const align_size = ~(this.bb.capacity() - this.space + additional_bytes) + 1 & size - 1;
    while (this.space < align_size + size + additional_bytes) {
      const old_buf_size = this.bb.capacity();
      this.bb = Builder.growByteBuffer(this.bb);
      this.space += this.bb.capacity() - old_buf_size;
    }
    this.pad(align_size);
  }
  pad(byte_size) {
    for (let i = 0; i < byte_size; i++) {
      this.bb.writeInt8(--this.space, 0);
    }
  }
  writeInt8(value) {
    this.bb.writeInt8(this.space -= 1, value);
  }
  writeInt16(value) {
    this.bb.writeInt16(this.space -= 2, value);
  }
  writeInt32(value) {
    this.bb.writeInt32(this.space -= 4, value);
  }
  writeInt64(value) {
    this.bb.writeInt64(this.space -= 8, value);
  }
  writeFloat32(value) {
    this.bb.writeFloat32(this.space -= 4, value);
  }
  writeFloat64(value) {
    this.bb.writeFloat64(this.space -= 8, value);
  }
  /**
   * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int8` to add the buffer.
   */
  addInt8(value) {
    this.prep(1, 0);
    this.writeInt8(value);
  }
  /**
   * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int16` to add the buffer.
   */
  addInt16(value) {
    this.prep(2, 0);
    this.writeInt16(value);
  }
  /**
   * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int32` to add the buffer.
   */
  addInt32(value) {
    this.prep(4, 0);
    this.writeInt32(value);
  }
  /**
   * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int64` to add the buffer.
   */
  addInt64(value) {
    this.prep(8, 0);
    this.writeInt64(value);
  }
  /**
   * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float32` to add the buffer.
   */
  addFloat32(value) {
    this.prep(4, 0);
    this.writeFloat32(value);
  }
  /**
   * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float64` to add the buffer.
   */
  addFloat64(value) {
    this.prep(8, 0);
    this.writeFloat64(value);
  }
  addFieldInt8(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addInt8(value);
      this.slot(voffset);
    }
  }
  addFieldInt16(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addInt16(value);
      this.slot(voffset);
    }
  }
  addFieldInt32(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addInt32(value);
      this.slot(voffset);
    }
  }
  addFieldInt64(voffset, value, defaultValue) {
    if (this.force_defaults || value !== defaultValue) {
      this.addInt64(value);
      this.slot(voffset);
    }
  }
  addFieldFloat32(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addFloat32(value);
      this.slot(voffset);
    }
  }
  addFieldFloat64(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addFloat64(value);
      this.slot(voffset);
    }
  }
  addFieldOffset(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addOffset(value);
      this.slot(voffset);
    }
  }
  /**
   * Structs are stored inline, so nothing additional is being added. `d` is always 0.
   */
  addFieldStruct(voffset, value, defaultValue) {
    if (value != defaultValue) {
      this.nested(value);
      this.slot(voffset);
    }
  }
  /**
   * Structures are always stored inline, they need to be created right
   * where they're used.  You'll get this assertion failure if you
   * created it elsewhere.
   */
  nested(obj) {
    if (obj != this.offset()) {
      throw new TypeError("FlatBuffers: struct must be serialized inline.");
    }
  }
  /**
   * Should not be creating any other object, string or vector
   * while an object is being constructed
   */
  notNested() {
    if (this.isNested) {
      throw new TypeError("FlatBuffers: object serialization must not be nested.");
    }
  }
  /**
   * Set the current vtable at `voffset` to the current location in the buffer.
   */
  slot(voffset) {
    if (this.vtable !== null)
      this.vtable[voffset] = this.offset();
  }
  /**
   * @returns Offset relative to the end of the buffer.
   */
  offset() {
    return this.bb.capacity() - this.space;
  }
  /**
   * Doubles the size of the backing ByteBuffer and copies the old data towards
   * the end of the new buffer (since we build the buffer backwards).
   *
   * @param bb The current buffer with the existing data
   * @returns A new byte buffer with the old data copied
   * to it. The data is located at the end of the buffer.
   *
   * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
   * it a uint8Array we need to suppress the type check:
   * @suppress {checkTypes}
   */
  static growByteBuffer(bb) {
    const old_buf_size = bb.capacity();
    if (old_buf_size & 3221225472) {
      throw new Error("FlatBuffers: cannot grow buffer beyond 2 gigabytes.");
    }
    const new_buf_size = old_buf_size << 1;
    const nbb = ByteBuffer.allocate(new_buf_size);
    nbb.setPosition(new_buf_size - old_buf_size);
    nbb.bytes().set(bb.bytes(), new_buf_size - old_buf_size);
    return nbb;
  }
  /**
   * Adds on offset, relative to where it will be written.
   *
   * @param offset The offset to add.
   */
  addOffset(offset) {
    this.prep(SIZEOF_INT, 0);
    this.writeInt32(this.offset() - offset + SIZEOF_INT);
  }
  /**
   * Start encoding a new object in the buffer.  Users will not usually need to
   * call this directly. The FlatBuffers compiler will generate helper methods
   * that call this method internally.
   */
  startObject(numfields) {
    this.notNested();
    if (this.vtable == null) {
      this.vtable = [];
    }
    this.vtable_in_use = numfields;
    for (let i = 0; i < numfields; i++) {
      this.vtable[i] = 0;
    }
    this.isNested = true;
    this.object_start = this.offset();
  }
  /**
   * Finish off writing the object that is under construction.
   *
   * @returns The offset to the object inside `dataBuffer`
   */
  endObject() {
    if (this.vtable == null || !this.isNested) {
      throw new Error("FlatBuffers: endObject called without startObject");
    }
    this.addInt32(0);
    const vtableloc = this.offset();
    let i = this.vtable_in_use - 1;
    for (; i >= 0 && this.vtable[i] == 0; i--) {
    }
    const trimmed_size = i + 1;
    for (; i >= 0; i--) {
      this.addInt16(this.vtable[i] != 0 ? vtableloc - this.vtable[i] : 0);
    }
    const standard_fields = 2;
    this.addInt16(vtableloc - this.object_start);
    const len = (trimmed_size + standard_fields) * SIZEOF_SHORT;
    this.addInt16(len);
    let existing_vtable = 0;
    const vt1 = this.space;
    outer_loop:
      for (i = 0; i < this.vtables.length; i++) {
        const vt2 = this.bb.capacity() - this.vtables[i];
        if (len == this.bb.readInt16(vt2)) {
          for (let j = SIZEOF_SHORT; j < len; j += SIZEOF_SHORT) {
            if (this.bb.readInt16(vt1 + j) != this.bb.readInt16(vt2 + j)) {
              continue outer_loop;
            }
          }
          existing_vtable = this.vtables[i];
          break;
        }
      }
    if (existing_vtable) {
      this.space = this.bb.capacity() - vtableloc;
      this.bb.writeInt32(this.space, existing_vtable - vtableloc);
    } else {
      this.vtables.push(this.offset());
      this.bb.writeInt32(this.bb.capacity() - vtableloc, this.offset() - vtableloc);
    }
    this.isNested = false;
    return vtableloc;
  }
  /**
   * Finalize a buffer, poiting to the given `root_table`.
   */
  finish(root_table, opt_file_identifier, opt_size_prefix) {
    const size_prefix = opt_size_prefix ? SIZE_PREFIX_LENGTH : 0;
    if (opt_file_identifier) {
      const file_identifier = opt_file_identifier;
      this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + size_prefix);
      if (file_identifier.length != FILE_IDENTIFIER_LENGTH) {
        throw new TypeError("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
      }
      for (let i = FILE_IDENTIFIER_LENGTH - 1; i >= 0; i--) {
        this.writeInt8(file_identifier.charCodeAt(i));
      }
    }
    this.prep(this.minalign, SIZEOF_INT + size_prefix);
    this.addOffset(root_table);
    if (size_prefix) {
      this.addInt32(this.bb.capacity() - this.space);
    }
    this.bb.setPosition(this.space);
  }
  /**
   * Finalize a size prefixed buffer, pointing to the given `root_table`.
   */
  finishSizePrefixed(root_table, opt_file_identifier) {
    this.finish(root_table, opt_file_identifier, true);
  }
  /**
   * This checks a required field has been set in a given table that has
   * just been constructed.
   */
  requiredField(table, field) {
    const table_start = this.bb.capacity() - table;
    const vtable_start = table_start - this.bb.readInt32(table_start);
    const ok = field < this.bb.readInt16(vtable_start) && this.bb.readInt16(vtable_start + field) != 0;
    if (!ok) {
      throw new TypeError("FlatBuffers: field " + field + " must be set");
    }
  }
  /**
   * Start a new array/vector of objects.  Users usually will not call
   * this directly. The FlatBuffers compiler will create a start/end
   * method for vector types in generated code.
   *
   * @param elem_size The size of each element in the array
   * @param num_elems The number of elements in the array
   * @param alignment The alignment of the array
   */
  startVector(elem_size, num_elems, alignment) {
    this.notNested();
    this.vector_num_elems = num_elems;
    this.prep(SIZEOF_INT, elem_size * num_elems);
    this.prep(alignment, elem_size * num_elems);
  }
  /**
   * Finish off the creation of an array and all its elements. The array must be
   * created with `startVector`.
   *
   * @returns The offset at which the newly created array
   * starts.
   */
  endVector() {
    this.writeInt32(this.vector_num_elems);
    return this.offset();
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If the string passed has
   * already been seen, we return the offset of the already written string
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createSharedString(s) {
    if (!s) {
      return 0;
    }
    if (!this.string_maps) {
      this.string_maps = /* @__PURE__ */ new Map();
    }
    if (this.string_maps.has(s)) {
      return this.string_maps.get(s);
    }
    const offset = this.createString(s);
    this.string_maps.set(s, offset);
    return offset;
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
   * instead of a string, it is assumed to contain valid UTF-8 encoded data.
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createString(s) {
    if (s === null || s === void 0) {
      return 0;
    }
    let utf8;
    if (s instanceof Uint8Array) {
      utf8 = s;
    } else {
      utf8 = this.text_encoder.encode(s);
    }
    this.addInt8(0);
    this.startVector(1, utf8.length, 1);
    this.bb.setPosition(this.space -= utf8.length);
    for (let i = 0, offset = this.space, bytes = this.bb.bytes(); i < utf8.length; i++) {
      bytes[offset++] = utf8[i];
    }
    return this.endVector();
  }
  /**
   * A helper function to pack an object
   *
   * @returns offset of obj
   */
  createObjectOffset(obj) {
    if (obj === null) {
      return 0;
    }
    if (typeof obj === "string") {
      return this.createString(obj);
    } else {
      return obj.pack(this);
    }
  }
  /**
   * A helper function to pack a list of object
   *
   * @returns list of offsets of each non null object
   */
  createObjectOffsetList(list) {
    const ret = [];
    for (let i = 0; i < list.length; ++i) {
      const val = list[i];
      if (val !== null) {
        ret.push(this.createObjectOffset(val));
      } else {
        throw new TypeError("FlatBuffers: Argument for createObjectOffsetList cannot contain null.");
      }
    }
    return ret;
  }
  createStructOffsetList(list, startFunc) {
    startFunc(this, list.length);
    this.createObjectOffsetList(list.slice().reverse());
    return this.endVector();
  }
}
const fatalLevel = 5;
const debugLevel = 1;
function isLogLevel(level) {
  return typeof level === "number" && level >= 0 && level < 7;
}
function toLogLevel(level) {
  if (typeof level === "undefined" || level === null) {
    return debugLevel;
  }
  return isLogLevel(level) ? level : fatalLevel;
}
function serialize(slug, level, data) {
  if (!slug || typeof slug !== "string") {
    return null;
  }
  const builder = new Builder(128);
  const messageOffset = builder.createString(slug);
  const fieldsArr = [];
  if (data) {
    for (const [key, value] of Object.entries(data)) {
      if (!key || typeof key !== "string" || value && typeof value !== "string") {
        continue;
      }
      const keyOffset = builder.createString(key);
      const valueOffset = builder.createString(value || "");
      builder.startObject(2);
      builder.addFieldOffset(0, keyOffset, 0);
      builder.addFieldOffset(1, valueOffset, 0);
      fieldsArr.unshift(builder.endObject());
    }
  }
  builder.startVector(4, fieldsArr.length, 4);
  for (const offset of fieldsArr) {
    builder.addOffset(offset);
  }
  const fieldsOffset = builder.endVector();
  builder.startObject(3);
  builder.addFieldOffset(0, messageOffset, 0);
  builder.addFieldInt8(1, toLogLevel(level), 0);
  builder.addFieldOffset(2, fieldsOffset, 0);
  builder.finish(builder.endObject());
  return builder.asUint8Array();
}
function enforceString(value) {
  switch (typeof value) {
    case "string":
      return value;
    case "number":
      return value.toFixed(0);
    case "bigint":
      return value.toString();
    case "symbol":
      return value.description || "";
    case "boolean":
      return value ? "1" : "0";
    default:
      return "";
  }
}
const _Log = class _Log {
  constructor(session, url) {
    __publicField(this, "_session", "");
    __publicField(this, "_userAgent", "<unknown>");
    __publicField(this, "_url");
    __publicField(this, "_lastId", 0);
    __publicField(this, "_app", []);
    this._session = session;
    this._userAgent = this.getUserAgent();
    this._url = url;
  }
  get session() {
    return this._session;
  }
  get app() {
    return this._app.join(",");
  }
  get userAgent() {
    return this._userAgent;
  }
  static register(config) {
    const parsedConfig = parseConfig(config);
    const OT = getGlobal();
    OT.Log = OT.Log || new _Log(parsedConfig.session, parsedConfig.url);
    OT.Log.addApp(parsedConfig.appName, parsedConfig.appVersion);
    if (parsedConfig.rawSession && OT.Log._session !== parsedConfig.rawSession) {
      OT.Log.linkSession(parsedConfig.rawSession);
    }
    return OT.Log;
  }
  captureSession(error) {
    error.id = ++this._lastId;
    error.session = this.session;
  }
  linkSession(session) {
    if (!session) {
      throw new Error("Missing the Log client session ID to link.");
    } else if (typeof session !== "string") {
      throw new Error(`The Log client session ID to link should be a string, got ${typeof session}.`);
    }
    if (this.session !== session) {
      this.send({
        slug: "log.session.link",
        message: "Link session",
        getLogContext() {
          return {
            _link_: session
          };
        }
      });
    }
  }
  send(error, level) {
    if (!error || error.otSent) {
      return error;
    }
    error.otSent = true;
    try {
      let { cause } = error;
      while (cause && !cause.otSent) {
        this.send(cause, level);
        cause = cause.cause;
      }
    } catch (_) {
    }
    try {
      const slug = enforceString(error.slug);
      const data = this.parseData(error, level);
      const serialized = serialize(slug, level, data);
      if (!serialized) {
        return error;
      }
      void (async () => {
        try {
          await globalThis.fetch(this._url, {
            body: serialized,
            headers: {},
            method: "POST",
            // Don't send AND don't process received cookies/credentials/TLS client certs.
            credentials: "omit",
            // cache: 'no-store' completely ignores any cache.
            // cache: 'no-cache' will do a conditional request to check if there is newer content.
            // E.g.: (no-cache won't use the cache immediately for fresh cached requests, but it will use it,
            // if the server responds 'not-modified'.
            cache: "no-store",
            // Allow the request to finish after unload.
            // This is not a guarantee, but it has the 'best'/only chance of success.
            // It is the replacement for the `Navigator.sendBeacon()` API.
            keepalive: true
          });
        } catch (_) {
        }
      })();
    } catch (_) {
    }
    return error;
  }
  addApp(appName, appVersion) {
    const app = `${appName}@${appVersion}`;
    if (!this._app.includes(app)) {
      this._app.push(app);
    }
  }
  getUserAgent() {
    try {
      const ua = navigator?.userAgent;
      if (ua && typeof ua === "string") {
        return ua;
      }
    } catch (_) {
    }
    return "<unknown>";
  }
  parseData(error, level) {
    let data = {};
    try {
      if (error.getLogContext && typeof error.getLogContext === "function") {
        const entries = Object.entries(error.getLogContext()).map(([key, value]) => [enforceString(key), enforceString(value)]);
        data = Object.fromEntries(entries);
      }
    } catch (_) {
    }
    try {
      return {
        ...data,
        _app_: enforceString(this.app),
        _href_: enforceString(error.href),
        _id_: enforceString(error.id || ++this._lastId),
        _level_: enforceString(level),
        _message_: enforceString(error.message),
        _session_: enforceString(this.session),
        _slug_: enforceString(error.slug),
        _ts_: enforceString(error.ts),
        _userAgent_: enforceString(this.userAgent)
      };
    } catch (_) {
      return {};
    }
  }
};
__publicField(_Log, "Trace", 0);
__publicField(_Log, "Debug", 1);
__publicField(_Log, "Info", 2);
__publicField(_Log, "Warn", 3);
__publicField(_Log, "Error", 4);
__publicField(_Log, "Fatal", 5);
__publicField(_Log, "Panic", 6);
let Log = _Log;
function registerLog(config) {
  try {
    return Log.register(config);
  } catch (e) {
    console.error("Failed to register log client", e);
  }
  return null;
}
function send(error, level) {
  try {
    const OT = getGlobal();
    if (OT.Log) {
      OT.Log.send(error, level);
    }
  } catch (_) {
  }
  return error;
}
function register(config) {
  const log = registerLog(config);
  if (log) {
    registerGlobalErrorHandlers();
  }
  return log;
}
export {
  Log,
  OtError,
  UnknownError,
  isOtError,
  register,
  registerGlobalErrorHandlers,
  registerLog,
  send
};
//# sourceMappingURL=ot-log.js.map
